/** Bounded SSE framing for POST conversation turn streams, typed or delegated from voice. */
export async function* sseFrames(reader: ReadableStreamDefaultReader<Uint8Array>): AsyncGenerator<string> {
  const decoder = new TextDecoder();
  let buffer = '';
  try {
    while (true) {
      const { value, done } = await reader.read();
      if (done) return;
      buffer = (buffer + decoder.decode(value, { stream: true })).replace(/\r\n/g, '\n');
      if (buffer.length > 4 * 1024 * 1024) throw new Error('Stream frame exceeds the limit.');
      let end: number;
      while ((end = buffer.indexOf('\n\n')) >= 0) {
        yield buffer.slice(0, end);
        buffer = buffer.slice(end + 2);
      }
    }
  } finally { try { await reader.cancel(); } catch { /* Already closed. */ } }
}
